import React from "react";
import Screen from "./Screen";
interface Props {}

export default (props: Props) => {
  return <Screen {...props} />;
};
